import { useContext } from 'react';

import { ErrorContext } from '@/components/errorBoundary/errorBoundary';

export const useErrorContext = () => useContext(ErrorContext);
